import { render } from "./ImagemProduto.vue?vue&type=template&id=83d4d94c&scoped=true"
import script from "./ImagemProduto.vue?vue&type=script&lang=js"
export * from "./ImagemProduto.vue?vue&type=script&lang=js"

import "./ImagemProduto.vue?vue&type=style&index=0&id=83d4d94c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d4d94c"]])

export default __exports__